export default __webpack_public_path__ + "static/media/menu.c3f63f78.svg";